var map = {
	"./Clinique-memoire_LOGO_FINAL_General-01.png": 39553,
	"./Picture1.png": 80043,
	"./alien.png": 35303,
	"./anatomical_heart.png": 34500,
	"./apple.png": 94758,
	"./balloon.png": 30791,
	"./bear.png": 88826,
	"./bell_pepper.png": 46104,
	"./black_heart.png": 67854,
	"./blossom.png": 35793,
	"./blue_heart.png": 33877,
	"./blueberries.png": 30926,
	"./bone.png": 61702,
	"./bouquet.png": 68833,
	"./brain.png": 94354,
	"./broccoli.png": 36797,
	"./brown_heart.png": 1119,
	"./butterfly.png": 79127,
	"./cat.png": 98518,
	"./cherry_blossom.png": 94137,
	"./chicken.png": 36111,
	"./christmas_tree.png": 20567,
	"./clown_face.png": 10025,
	"./confetti_ball.png": 95878,
	"./corn.png": 17266,
	"./cow.png": 26403,
	"./dog.png": 28032,
	"./eye.png": 93893,
	"./fallen_leaf.png": 58695,
	"./fire.png": 20336,
	"./firecracker.png": 85905,
	"./flag-ca.png": 81101,
	"./four_leaf_clover.png": 56405,
	"./frog.png": 34670,
	"./ghost.png": 65723,
	"./gift.png": 20758,
	"./gift_heart.png": 48023,
	"./grapes.png": 72432,
	"./green_apple.png": 11930,
	"./green_heart.png": 85966,
	"./grey_heart.png": 13192,
	"./hamster.png": 29716,
	"./heart.png": 53130,
	"./hearts.png": 94251,
	"./hibiscus.png": 51732,
	"./hot_pepper.png": 91876,
	"./innocent.png": 35158,
	"./jack_o_lantern.png": 32662,
	"./japanese_ogre.png": 25355,
	"./kiss.png": 68902,
	"./kissing_heart.png": 10769,
	"./koala.png": 27848,
	"./leaves.png": 78384,
	"./lemon.png": 80715,
	"./light_blue_heart.png": 13118,
	"./logo192.png": 11481,
	"./lungs.png": 52145,
	"./maple_leaf.png": 82390,
	"./mushroom.png": 10174,
	"./orange_heart.png": 13891,
	"./panda_face.png": 56476,
	"./peach.png": 47561,
	"./pig.png": 56094,
	"./pink_heart.png": 75461,
	"./polar_bear.png": 62793,
	"./purple_heart.png": 92903,
	"./rabbit.png": 38100,
	"./rainbow.png": 51520,
	"./rose.png": 66889,
	"./rosette.png": 49264,
	"./skull.png": 80029,
	"./skull_and_crossbones.png": 13113,
	"./smiling_imp.png": 83872,
	"./space_invader.png": 2486,
	"./sparkling_heart.png": 47424,
	"./star2.png": 37616,
	"./strawberry.png": 11711,
	"./tada.png": 25788,
	"./tangerine.png": 76287,
	"./tongue.png": 54228,
	"./trophy.png": 68782,
	"./turkey.png": 6502,
	"./unicorn_face.png": 3192,
	"./white_heart.png": 44984,
	"./yellow_heart.png": 36169
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92183;